export default __webpack_public_path__ + "static/media/logo.002b71e4.png";